import {defineStore} from "pinia";
import Installation from "@/shared/model/Installation";
import {User} from "@/shared/model/User";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {Action, allActions, allRootActions} from "@/shared/model/Action";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {ref} from "vue";
import {computed} from "vue";
import {useCookies} from "vue3-cookies";


export const useAccountStore = defineStore("account", () => {

  const _actionPerson = ref<Person | undefined>(undefined);
  const _person = ref<Person | undefined>(undefined);

  const addresses = ref<Address[] | undefined>(undefined);
  const details = ref<PersonDetails | undefined>(undefined);
  const user = ref<User | undefined>(undefined);
  const installation = ref<Installation>({} as Installation);
  const authenticated = ref(false)
  const hasExportBlankProduct = ref<boolean|undefined>(false)
    const dark = ref(useCookies().cookies.get("dark") === "true");


  function setInstallation(value: Installation) {
    installation.value = value;
  }

  function setActionPerson(value: Person) {
    _actionPerson.value = value;
    if(value===undefined){
      return
    }
    p_initDark();
  }

  function p_initDark(){
    const t_externalInterface = details.value?.getValue(PersonDetailsId.ExternalInterface)
    if(t_externalInterface==="kroschke" ||_person.value?.isBranch()){
      dark.value = false
    }
    else{
      dark.value = true
    }
  }

  function setPerson(value: Person) {
    _person.value = value;
    if(value===undefined){
      return
    }
    p_initDark();
  }


  function hasAction(action: string | Action): boolean {
    return (
      (user.value &&
        user.value.actions.some(
          (t) => t.toLowerCase() === action.toLowerCase()
        )) ??
      false
    );
  }

  function hasAccountingLicense(): boolean {
    return isRoot.value
  }

  function getInvoiceAddressId(): string {
    return details.value?.getValue(PersonDetailsId.InvoiceAddressId) ?? "";
  }

  function getAddress(id: string): Address | undefined {
    if (addresses.value) {
      return addresses.value.find((t) => t.id == id);
    }
    return undefined;
  }

  function getInvoiceAddress(): Address | undefined {
    const id = getInvoiceAddressId();
    if (id) return getAddress(id);
    if (addresses.value && addresses.value.length > 0) return addresses.value[0];
    return undefined;
  }

  const isRoot = computed(() => {
    return (_person.value && _person.value.id === "person_agent22") ?? false;
  })

  const actionPerson = computed(()=>_actionPerson.value);
  const person = computed(()=>_person.value);

  const isBranch = computed(() => {
    return (_person.value && _person.value.isBranch()) ?? false;
  })

  function getManagedActions(): {
    id: string;
    checked: boolean;
    description: string;
  }[] {
    if (isRoot.value) {
      return [...allRootActions];
    }
    return [...allActions];
  }


  return {
    hasAction,
    setInstallation,
    setActionPerson,
    setPerson,
    hasAccountingLicense,
    getInvoiceAddressId,
    getAddress,
    getInvoiceAddress,
    getManagedActions,
    actionPerson, person, addresses, details, user, installation, authenticated,
    isRoot, isBranch,hasExportBlankProduct,dark
  };
});
